import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import styles from './styles.css';

@autobind
export default class Toggle extends Component {
    static propTypes = {
        type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
        value: PropTypes.bool.isRequired,
        label: PropTypes.node,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        readOnly: PropTypes.bool,
    };

    handleChange(event) {
        if (this.props.onChange) this.props.onChange(event.target.checked);
        if (this.props.onBlur) this.props.onBlur();
    }

    renderIcon() {
        if (this.props.type === 'checkbox') {
            return this.props.value ? 'check_box' : 'check_box_outline_blank';
        }

        if (this.props.type === 'radio') {
            return this.props.value ? 'radio_button_checked' : 'radio_button_unchecked';
        }
    }

    render() {
        return (
            <label className={classNames(styles.root, {[styles.disabled]: this.props.disabled})}>
                <i className='material-icons'>{this.renderIcon()}</i>
                {this.props.label && <span className={styles.label}>{this.props.label}</span>}
                {!this.props.readOnly && (
                    <input
                        type='checkbox'
                        checked={this.props.value}
                        disabled={this.props.disabled}
                        onChange={this.handleChange}
                        onBlur={this.props.onBlur}
                    />
                )}
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/toggle/index.js